/* eslint-disable max-len */
import api from '../../../services/api';

const API_URL = '/api/v1/manager/bidProfile/draft';

/**
 * @returns {Promise<ApiManager.GetAllBidProfileDraftResponse>}
 */
export const getAllDrafts = () => api.get(API_URL);

/**
 * @param {string} draftId
 * @returns {Promise<ApiManager.GetBidProfileDraftResponse>}
 */
export const getDraft = (draftId) => api.get(`${API_URL}/${draftId}`);

/**
 * @param {string} draftId
 * @returns {Promise<ApiManager.GetBidProfileScheduleItemsDraftResponse>}
 */
export const getBidProfileScheduleItemsDraft = (draftId) => api.get(`${API_URL}/${draftId}/scheduleItems`);

/**
 * @returns {Promise<ApiManager.UpdatedBidProfileDraftResponse>}
 */
export const createBiddingDraft = () => api.post(API_URL);

/**
 * @param {string} draftId
 * @returns {Promise<import('axios').AxiosResponse<any>>}
 */
export const deleteBiddingDraft = (draftId) => api.delete(`${API_URL}/${draftId}`);

/**
 * @param {string} draftId
 * @param {BiddingDraft.IDraftBidProfileInformationAccordion} biddingInformation
 * @returns {Promise<ApiManager.UpdatedBidProfileDraftResponse>}
 */
export const updateBiddingInformationDraft = (draftId, biddingInformation) => api.put(`${API_URL}/${draftId}/biddingInformation`, biddingInformation);

/**
 * @param {string} draftId
 * @param {number[]} selectedIds
 * @returns {Promise<ApiManager.GetBidProfileDraftResponse>}
 */
export const selectSchedulePatternTemplatesDraft = (draftId, selectedIds) => api.put(`${API_URL}/${draftId}/selectSchedulePatternTemplates`, { SelectedScheduleTemplateItemIds: selectedIds });

/**
 * @param {string} profileId
 * @param {string[]} selectedIds
 * @param {boolean} isRefresh
 * @returns {Promise<ApiManager.GetBidProfileDraftResponse>}
 */
export const selectWorkplansDraft = (profileId, selectedIds, isRefresh) => api.put(`${API_URL}/${profileId}/SelectWorkplans`, { SelectedWorkplanIds: selectedIds, isRefresh });

/**
 * @param {string} draftId
 * @param {BidProfile.IUpdateEmployeeSelection} employees
 * @returns {Promise<ApiManager.GetBidProfileDraftResponse>}
 */
export const updateEmployeeSelectionDraft = (draftId, employees) => api.put(`${API_URL}/${draftId}/employees`, employees);

/**
 * @param {string} draftId
 * @param {ApiManager.ISchedulingAndVisibilityPresentationModel} schedulePeriod
 * @returns {Promise<ApiManager.UpdatedBidProfileDraftResponse>}
 */
export const updateschedulePeriodDraft = (draftId, schedulePeriod) => api.put(`${API_URL}/${draftId}/schedulingAndVisibility`, schedulePeriod);

/**
 * @param {string} draftId
 * @returns {Promise<ApiManager.UpdatedBidProfileResponse>}
 */
export const complete = (draftId) => api.post(`${API_URL}/${draftId}/complete`);

/**
 * @param {string} draftId
 * @returns {Promise<ApiManager.GetBidProfileDraftResponse>}
 */
export const duplicateBiddingDraft = (draftId) => api.post(`${API_URL}/${draftId}/duplicate`);

/**
 * @param {string} draftId
 * @param {number} hyperfindId
 * @param {Date|null} startDate
 * @param {Date|null} endDate
 * @returns {Promise<ApiManager.DataviewResponse>}
 */
export const executeDataviewDraft = (draftId, hyperfindId, startDate, endDate) => api.post(`${API_URL}/${draftId}/dataview/execute`, { hyperfindId, startDate, endDate });

/**
 * @param {string} draftId
 * @param {any} excelFile
 * @returns {Promise<ApiManager.GetBidProfileScheduleItemsDraftResponse>}
 */
export const uploadExcelScheduleTemplatesDraft = (draftId, excelFile) => {
    const bodyFormData = new FormData();
    const configs = {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    };

    bodyFormData.append('excelFile', excelFile);

    return api.put(`${API_URL}/${draftId}/uploadExcelScheduleTemplates`, bodyFormData, configs);
};

/**
 * @param {string} draftId
 * @returns {Promise<any>}
 */
export const downloadExcelTemplateDraft = (draftId) => {
    const configs = {
        headers: {
            'Content-Type': 'blob',
        },
        responseType: 'arraybuffer',
    };

    return api.get(`${API_URL}/${draftId}/DownloadExcelTemplate`, configs);
};

/**
 * @param {string} draftId
 * @param {ApiManager.EmployeeSchedulesBody} employeeScheduleBody
 * @returns {Promise<ApiManager.GetSequentialEmployeeScheduleDraftResponse>}
 */
export const sequentialEmployeeScheduleDraft = (draftId, employeeScheduleBody) => api.post(`${API_URL}/${draftId}/preview/sequentialEmployeeSchedule`, employeeScheduleBody);

/**
 * @param {string} draftId
 * @returns {Promise<ApiManager.GetDraftImportProgressStatusQueryResponse>}
*/
export const getDraftImportScheduleProgressStatusQuery = (draftId) => api.get(`${API_URL}/${draftId}/importSchedule/status`);
